import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

export const getIcon = (type, title = '', category = '') => {
  const lowerTitle = title.toLowerCase();
  
  switch (true) {
    // Category-based cases
    case category === 'expenseReport':
      return <ReceiptRoundedIcon />;
      
    // Title-based cases
    case lowerTitle.includes('utilisateur crée avec succès'):
      return <PersonAddIcon />;
    case lowerTitle.includes('pointage de sortie'):
      return <AccessTimeRoundedIcon />;
    case lowerTitle.includes('pointage d\'entrée'):
      return <AccessTimeRoundedIcon />;
    case lowerTitle.includes('schedule validation'):
      return <EventAvailableIcon />;
    case lowerTitle.includes('attendance validation policy'):
      return <VerifiedUserIcon />;

    
    // Default case
    default:
      return <NotificationsRoundedIcon />;
  }
}